
import React from "react";
import { Hero, Services, AboutUs,Categories,OverView,
   Projects, WhatWeDo } from "../components/home";
import Counter from "../components/home/Counter";
import Testimonial from "../components/home/Testimonial";


const Home = () => {
  return (
    <div className="pt-16">
      <Hero />
      <WhatWeDo />
      <Counter/>
      <AboutUs />
      <OverView/>
      <Categories/>
      <Services />
      <Projects />  
      <Testimonial/>
    </div>
  );
};

export default Home;
